import { sortBy } from "lib/lodash";

export const priorityCountries = [
  { key: "US", label: "United States of America" },
  { key: "AU", label: "Australia" },
  { key: "GB", label: "United Kingdom" },
  { key: "CA", label: "Canada" }
];

export const secondaryCountries = [
  { key: "AD", label: "Andorra" },
  { key: "AE", label: "United Arab Emirates" },
  { key: "AF", label: "Afghanistan" },
  { key: "AG", label: "Antigua and Barbuda" },
  { key: "AI", label: "Anguilla" },
  { key: "AL", label: "Albania" },
  { key: "AM", label: "Armenia" },
  { key: "AO", label: "Angola" },
  { key: "AQ", label: "Antarctica" },
  { key: "AR", label: "Argentina" },
  { key: "AS", label: "American Samoa" },
  { key: "AT", label: "Austria" },
  { key: "AW", label: "Aruba" },
  { key: "AX", label: "Åland Islands" },
  { key: "AZ", label: "Azerbaijan" },
  { key: "BA", label: "Bosnia and Herzegovina" },
  { key: "BB", label: "Barbados" },
  { key: "BD", label: "Bangladesh" },
  { key: "BE", label: "Belgium" },
  { key: "BF", label: "Burkina Faso" },
  { key: "BG", label: "Bulgaria" },
  { key: "BH", label: "Bahrain" },
  { key: "BI", label: "Burundi" },
  { key: "BJ", label: "Benin" },
  { key: "BL", label: "Saint Barthélemy" },
  { key: "BM", label: "Bermuda" },
  { key: "BN", label: "Brunei Darussalam" },
  { key: "BO", label: "Bolivia, Plurinational State of" },
  { key: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
  { key: "BR", label: "Brazil" },
  { key: "BS", label: "Bahamas" },
  { key: "BT", label: "Bhutan" },
  { key: "BV", label: "Bouvet Island" },
  { key: "BW", label: "Botswana" },
  { key: "BY", label: "Belarus" },
  { key: "BZ", label: "Belize" },
  { key: "CC", label: "Cocos (Keeling) Islands" },
  { key: "CD", label: "Congo, the Democratic Republic of the" },
  { key: "CF", label: "Central African Republic" },
  { key: "CG", label: "Congo" },
  { key: "CH", label: "Switzerland" },
  { key: "CI", label: "Côte d'Ivoire" },
  { key: "CK", label: "Cook Islands" },
  { key: "CL", label: "Chile" },
  { key: "CM", label: "Cameroon" },
  { key: "CN", label: "China" },
  { key: "CO", label: "Colombia" },
  { key: "CR", label: "Costa Rica" },
  { key: "CU", label: "Cuba" },
  { key: "CV", label: "Cabo Verde" },
  { key: "CW", label: "Curaçao" },
  { key: "CX", label: "Christmas Island" },
  { key: "CY", label: "Cyprus" },
  { key: "CZ", label: "Czechia" },
  { key: "DE", label: "Germany" },
  { key: "DJ", label: "Djibouti" },
  { key: "DK", label: "Denmark" },
  { key: "DM", label: "Dominica" },
  { key: "DO", label: "Dominican Republic" },
  { key: "DZ", label: "Algeria" },
  { key: "EC", label: "Ecuador" },
  { key: "EE", label: "Estonia" },
  { key: "EG", label: "Egypt" },
  { key: "EH", label: "Western Sahara" },
  { key: "ER", label: "Eritrea" },
  { key: "ES", label: "Spain" },
  { key: "ET", label: "Ethiopia" },
  { key: "FI", label: "Finland" },
  { key: "FJ", label: "Fiji" },
  { key: "FK", label: "Falkland Islands (Malvinas)" },
  { key: "FM", label: "Micronesia, Federated States of" },
  { key: "FO", label: "Faroe Islands" },
  { key: "FR", label: "France" },
  { key: "GA", label: "Gabon" },
  { key: "GD", label: "Grenada" },
  { key: "GE", label: "Georgia" },
  { key: "GF", label: "French Guiana" },
  { key: "GG", label: "Guernsey" },
  { key: "GH", label: "Ghana" },
  { key: "GI", label: "Gibraltar" },
  { key: "GL", label: "Greenland" },
  { key: "GM", label: "Gambia" },
  { key: "GN", label: "Guinea" },
  { key: "GP", label: "Guadeloupe" },
  { key: "GQ", label: "Equatorial Guinea" },
  { key: "GR", label: "Greece" },
  { key: "GS", label: "South Georgia and the South Sandwich Islands" },
  { key: "GT", label: "Guatemala" },
  { key: "GU", label: "Guam" },
  { key: "GW", label: "Guinea-Bissau" },
  { key: "GY", label: "Guyana" },
  { key: "HK", label: "Hong Kong" },
  { key: "HM", label: "Heard Island and McDonald Islands" },
  { key: "HN", label: "Honduras" },
  { key: "HR", label: "Croatia" },
  { key: "HT", label: "Haiti" },
  { key: "HU", label: "Hungary" },
  { key: "ID", label: "Indonesia" },
  { key: "IE", label: "Ireland" },
  { key: "IL", label: "Israel" },
  { key: "IM", label: "Isle of Man" },
  { key: "IN", label: "India" },
  { key: "IO", label: "British Indian Ocean Territory" },
  { key: "IQ", label: "Iraq" },
  { key: "IR", label: "Iran, Islamic Republic of" },
  { key: "IS", label: "Iceland" },
  { key: "IT", label: "Italy" },
  { key: "JE", label: "Jersey" },
  { key: "JM", label: "Jamaica" },
  { key: "JO", label: "Jordan" },
  { key: "JP", label: "Japan" },
  { key: "KE", label: "Kenya" },
  { key: "KG", label: "Kyrgyzstan" },
  { key: "KH", label: "Cambodia" },
  { key: "KI", label: "Kiribati" },
  { key: "KM", label: "Comoros" },
  { key: "KN", label: "Saint Kitts and Nevis" },
  { key: "KP", label: "Korea, Democratic People's Republic of" },
  { key: "KR", label: "Korea, Republic of" },
  { key: "KW", label: "Kuwait" },
  { key: "KY", label: "Cayman Islands" },
  { key: "KZ", label: "Kazakhstan" },
  { key: "LA", label: "Lao People's Democratic Republic" },
  { key: "LB", label: "Lebanon" },
  { key: "LC", label: "Saint Lucia" },
  { key: "LI", label: "Liechtenstein" },
  { key: "LK", label: "Sri Lanka" },
  { key: "LR", label: "Liberia" },
  { key: "LS", label: "Lesotho" },
  { key: "LT", label: "Lithuania" },
  { key: "LU", label: "Luxembourg" },
  { key: "LV", label: "Latvia" },
  { key: "LY", label: "Libya" },
  { key: "MA", label: "Morocco" },
  { key: "MC", label: "Monaco" },
  { key: "MD", label: "Moldova, Republic of" },
  { key: "ME", label: "Montenegro" },
  { key: "MF", label: "Saint Martin (French part)" },
  { key: "MG", label: "Madagascar" },
  { key: "MH", label: "Marshall Islands" },
  { key: "MK", label: "Macedonia, the former Yugoslav Republic of" },
  { key: "ML", label: "Mali" },
  { key: "MM", label: "Myanmar" },
  { key: "MN", label: "Mongolia" },
  { key: "MO", label: "Macao" },
  { key: "MP", label: "Northern Mariana Islands" },
  { key: "MQ", label: "Martinique" },
  { key: "MR", label: "Mauritania" },
  { key: "MS", label: "Montserrat" },
  { key: "MT", label: "Malta" },
  { key: "MU", label: "Mauritius" },
  { key: "MV", label: "Maldives" },
  { key: "MW", label: "Malawi" },
  { key: "MX", label: "Mexico" },
  { key: "MY", label: "Malaysia" },
  { key: "MZ", label: "Mozambique" },
  { key: "NA", label: "Namibia" },
  { key: "NC", label: "New Caledonia" },
  { key: "NE", label: "Niger" },
  { key: "NF", label: "Norfolk Island" },
  { key: "NG", label: "Nigeria" },
  { key: "NI", label: "Nicaragua" },
  { key: "NL", label: "Netherlands" },
  { key: "NO", label: "Norway" },
  { key: "NP", label: "Nepal" },
  { key: "NR", label: "Nauru" },
  { key: "NU", label: "Niue" },
  { key: "NZ", label: "New Zealand" },
  { key: "OM", label: "Oman" },
  { key: "PA", label: "Panama" },
  { key: "PE", label: "Peru" },
  { key: "PF", label: "French Polynesia" },
  { key: "PG", label: "Papua New Guinea" },
  { key: "PH", label: "Philippines" },
  { key: "PK", label: "Pakistan" },
  { key: "PL", label: "Poland" },
  { key: "PM", label: "Saint Pierre and Miquelon" },
  { key: "PN", label: "Pitcairn" },
  { key: "PR", label: "Puerto Rico" },
  { key: "PS", label: "Palestine, State of" },
  { key: "PT", label: "Portugal" },
  { key: "PW", label: "Palau" },
  { key: "PY", label: "Paraguay" },
  { key: "QA", label: "Qatar" },
  { key: "RE", label: "Réunion" },
  { key: "RO", label: "Romania" },
  { key: "RS", label: "Serbia" },
  { key: "RU", label: "Russian Federation" },
  { key: "RW", label: "Rwanda" },
  { key: "SA", label: "Saudi Arabia" },
  { key: "SB", label: "Solomon Islands" },
  { key: "SC", label: "Seychelles" },
  { key: "SD", label: "Sudan" },
  { key: "SE", label: "Sweden" },
  { key: "SG", label: "Singapore" },
  { key: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
  { key: "SI", label: "Slovenia" },
  { key: "SJ", label: "Svalbard and Jan Mayen" },
  { key: "SK", label: "Slovakia" },
  { key: "SL", label: "Sierra Leone" },
  { key: "SM", label: "San Marino" },
  { key: "SN", label: "Senegal" },
  { key: "SO", label: "Somalia" },
  { key: "SR", label: "Suriname" },
  { key: "SS", label: "South Sudan" },
  { key: "ST", label: "Sao Tome and Principe" },
  { key: "SV", label: "El Salvador" },
  { key: "SX", label: "Sint Maarten (Dutch part)" },
  { key: "SY", label: "Syrian Arab Republic" },
  { key: "SZ", label: "Swaziland" },
  { key: "TC", label: "Turks and Caicos Islands" },
  { key: "TD", label: "Chad" },
  { key: "TF", label: "French Southern Territories" },
  { key: "TG", label: "Togo" },
  { key: "TH", label: "Thailand" },
  { key: "TJ", label: "Tajikistan" },
  { key: "TK", label: "Tokelau" },
  { key: "TL", label: "Timor-Leste" },
  { key: "TM", label: "Turkmenistan" },
  { key: "TN", label: "Tunisia" },
  { key: "TO", label: "Tonga" },
  { key: "TR", label: "Turkey" },
  { key: "TT", label: "Trinidad and Tobago" },
  { key: "TV", label: "Tuvalu" },
  { key: "TW", label: "Taiwan, Province of China" },
  { key: "TZ", label: "Tanzania, United Republic of" },
  { key: "UA", label: "Ukraine" },
  { key: "UG", label: "Uganda" },
  { key: "UM", label: "United States Minor Outlying Islands" },
  { key: "UY", label: "Uruguay" },
  { key: "UZ", label: "Uzbekistan" },
  { key: "VA", label: "Holy See" },
  { key: "VC", label: "Saint Vincent and the Grenadines" },
  { key: "VE", label: "Venezuela, Bolivarian Republic of" },
  { key: "VG", label: "Virgin Islands, British" },
  { key: "VI", label: "Virgin Islands, U.S." },
  { key: "VN", label: "Viet Nam" },
  { key: "VU", label: "Vanuatu" },
  { key: "WF", label: "Wallis and Futuna" },
  { key: "WS", label: "Samoa" },
  { key: "YE", label: "Yemen" },
  { key: "YT", label: "Mayotte" },
  { key: "ZA", label: "South Africa" },
  { key: "ZM", label: "Zambia" },
  { key: "ZW", label: "Zimbabwe" }
];

export const allCountries = sortBy(
  [].concat(priorityCountries, secondaryCountries),
  ({ label }) => label
);
